module.exports = new Promise(resolve => {
	/* if(!["/corptravel/subscription","/corptravel/referral"].some(url=>window.location.pathname.includes(url))) return resolve({}); */
	const remoteUrlWithVersion = 'https://jsak.mmtcdn.com/mybiz-common/assets/dist/client/remoteEntry.js?v='+[window.commonAppVer]
	const script = document.createElement('script')
	script.src = remoteUrlWithVersion
	script.onload = () => {
		const proxy = {
			get: (request) => window.corpCommon.get(request),
			init: (arg) => {
				try {
					return window.corpCommon.init(arg)
				} catch(e) {
					console.log('container already initialized')
				}
			}
		}
		resolve(proxy)
	}
	script.onerror = (error) => {
		const proxy = {
			get: (request) => {
				return Promise.resolve(() => () => {
					var errorDiv = document.createElement('div')
					errorDiv.innerHTML = '<div style="text-align:center; margin-top:30px;">'
						+'<img width="300" src="https://imgak.mmtcdn.com/mybiz/assets/images/server-error.png" alt="Error"/>'
						+'<p style="color:#A73752; text-align:center;font-weight:700; margin-top:60px; font-size:20px">Error Serving Page</p>'
						+'<p>Error Fetching corpCommon module </p>'
						+'<a style="color: #0084ff;text-decoration: none;font-size: 18px;" href="//mybiz.makemytrip.com">Go to Homepage</a>'
					+'</div>'
					
					setTimeout(()=>{document.querySelectorAll('#root')[0].appendChild(errorDiv)})
					return null
				});
			},
			init: (arg) => {
				return;
			}
		}
		resolve(proxy)
	}
	document.head.appendChild(script);
});